import { render, staticRenderFns } from "./AWSServicesInput.vue?vue&type=template&id=e0f5d54c&scoped=true&"
import script from "./AWSServicesInput.vue?vue&type=script&lang=ts&"
export * from "./AWSServicesInput.vue?vue&type=script&lang=ts&"
import style0 from "./AWSServicesInput.vue?vue&type=style&index=0&id=e0f5d54c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f5d54c",
  null
  
)

export default component.exports